<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索" @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '添加招聘会')" class="search-btn">添加招聘会</Button>
            </slot>
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
            <Button type="default" class="search-btn" @click="handleExcelImportMapping" v-if="rules.excel_import_btn">导入字段设置</Button>

          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">

              <FormItem
                label="招聘会主题"
                prop="Jname"
              >
                <Input
                  v-model="formValidate.Jname"
                  :maxlength="45"
                  placeholder="请输入招聘会主题"
                ></Input>

              </FormItem>
              <FormItem label="开始时间" prop="Jstime">
                <DatePicker  type="datetime" editable v-model="formValidate.Jstime" format="yyyy-MM-dd HH:mm:ss" placement="bottom-end" placeholder="请选择开始时间" ></DatePicker>
              </FormItem>

              <FormItem label="结束时间" prop="Jotime">
                <DatePicker  type="datetime" editable v-model="formValidate.Jotime" format="yyyy-MM-dd HH:mm:ss" placement="bottom-end" placeholder="请选择开始时间" ></DatePicker>
              </FormItem>
              <FormItem label="招聘会类型" prop="Jtype">
                <Select  v-model="formValidate.Jtype" placeholder="请选择招聘会类型" filterable>
                  <Option v-for="item in JtypeList" :value="item.value" :key="item.id">{{item.meaning}}</Option>
                </Select>
              </FormItem>
              <FormItem label="实体摊位数量" prop="Jnum">
                <Input
                  v-model="formValidate.Jnum"
                  :maxlength="10"
                  placeholder="请输入实体摊位数量"
                ></Input></FormItem>
              <FormItem label="招聘市场" prop="Mid">
                <Select  v-model="formValidate.Mid" placeholder="请选择市场" filterable>
                  <Option v-for="item in MarketList" :value="item.Mid" :key="item.Id">{{item.Mname}}</Option>
                </Select>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>

            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>

    <!-- 导入职位进度窗口 -->
    <Modal
      v-model="importProgressVisible"
      title="职位导入进度"
      width="500px"
      :closable="false"
      :mask-closable="false"
      :footer-hide="true"
    >
      <div class="import-progress-container">
        <div class="progress-content">
          <Progress
            :percent="importPercent"
            :stroke-width="10"
            :status="importStatus"
          />
          <div class="progress-text">{{ importProgressText }}</div>
          <div class="progress-status">{{ importStatusText }}</div>
          <div class="progress-tip" v-if="importPercent < 100">导入中请勿关闭窗口...</div>
        </div>
      </div>
    </Modal>

    <!-- 查看摊位窗口 -->
    <Modal
      v-model="boothModalVisible"
      :title="boothModalTitle"
      width="1200px"
      :styles="{ top: '20px' }"
    >
      <div class="booth-container">
        <Tabs v-model="boothActiveTab">
          <TabPane label="摊位列表" name="booth">
          <Spin size="large" fix v-if="boothLoading"></Spin>
            <Table
              :columns="boothColumns"
              :data="boothData"
              :loading="boothLoading"
              border
              stripe
              height="500"
            >
              <template slot-scope="{ row }" slot="action">
                <Button type="primary" size="small" @click="handleViewBoothJobs(row)" style="margin-right: 5px;">查看职位</Button>
                <Button type="warning" size="small" @click="handleEditBoothNum(row)">修改摊位号</Button>
              </template>
            </Table>
            <div style="margin: 10px; overflow: hidden; margin-top: 10px;">
              <div style="float: right;">
                <Page :total="boothTotal" :current="boothPageNum" :page-size="boothPageSize" :page-size-opts=[10,20,50,100]
                      show-sizer show-total @on-change="changeBoothPage" @on-page-size-change="handleBoothPageSize">
                </Page>
              </div>
            </div>
          </TabPane>
          <TabPane label="职位列表" name="jobs">
          <Spin size="large" fix v-if="jobLoading"></Spin>
            <Table
              :columns="jobColumns"
              :data="jobData"
              :loading="jobLoading"
              border
              stripe
              height="500"
            />
            <div style="margin: 10px; overflow: hidden; margin-top: 10px;">
              <div style="float: right;">
                <Page :total="jobTotal" :current="jobPageNum" :page-size="jobPageSize" :page-size-opts=[10,20,50,100]
                      show-sizer show-total @on-change="changeJobPage" @on-page-size-change="handleJobPageSize">
                </Page>
              </div>
            </div>
          </TabPane>
        </Tabs>
      </div>
      <div slot="footer">
        <Button @click="boothModalVisible = false">关闭</Button>
      </div>
    </Modal>

    <!-- 修改摊位号弹窗 -->
    <Modal
      v-model="editBoothModalVisible"
      title="修改摊位号"
      width="400px"
    >
      <Form ref="editBoothForm" :model="editBoothForm" label-position="left">
        <FormItem label="企业名称">
          {{ editBoothForm.companyName }}
        </FormItem>
        <FormItem label="当前摊位号">
          {{ editBoothForm.currentNum }}
        </FormItem>
        <FormItem label="新摊位号" prop="newNum">
          <Input
            v-model="editBoothForm.newNum"
            style="width: 100%"
            placeholder="请输入新摊位号"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="editBoothModalVisible = false">取消</Button>
        <Button type="primary" @click="handleSaveBoothNum">确定</Button>
      </div>
    </Modal>

    <!-- 导入字段设置弹窗 -->
    <Modal
      v-model="excelMappingModalVisible"
      title="导入字段设置"
      width="1000px"
      :styles="{ top: '20px' }"
    >
      <Tabs v-model="excelMappingActiveTab">
        <TabPane label="配置列表" name="list">
          <div class="mapping-list-container">
            <div style="margin-bottom: 10px;">
              <Button type="primary" @click="handleAddMapping">新增配置</Button>
            </div>
            <Spin size="large" fix v-if="excelMappingLoading"></Spin>
            <Table
              :columns="excelMappingColumns"
              :data="excelMappingData"
              :loading="excelMappingLoading"
              border
              stripe
              height="400"
            >
              <template slot-scope="{ row }" slot="action">
                <Button type="primary" size="small" @click="handleEditMapping(row)" style="margin-right: 5px;">编辑</Button>
                <Button type="success" size="small" @click="handleSetDefaultMapping(row)" style="margin-right: 5px;" v-if="!row.is_default">设为默认</Button>
                <Button type="error" size="small" @click="handleDeleteMapping(row)">删除</Button>
              </template>
            </Table>
            <div style="margin-top: 10px;">
              <Page :total="excelMappingTotal" :current="excelMappingPageNum" :page-size="excelMappingPageSize"
                    show-sizer show-total @on-change="changeExcelMappingPage" @on-page-size-change="handleExcelMappingPageSize">
              </Page>
            </div>
          </div>
        </TabPane>
        <TabPane label="编辑配置" name="edit">
          <div class="mapping-edit-container">
            <Form ref="excelMappingForm" :model="excelMappingForm" :rules="excelMappingRules" :label-width="120">
              <FormItem label="配置名称" prop="mapping_name">
                <Input v-model="excelMappingForm.mapping_name" placeholder="请输入配置名称" />
              </FormItem>
              <FormItem label="字段行号" prop="header_row">
                <InputNumber v-model="excelMappingForm.header_row" :min="1" :max="100" style="width: 100%" placeholder="请输入字段行号" />
              </FormItem>
              <FormItem label="数据起始行号" prop="data_start_row">
                <InputNumber v-model="excelMappingForm.data_start_row" :min="1" :max="100" style="width: 100%" placeholder="请输入数据起始行号" />
              </FormItem>
              <FormItem label="设为默认">
                <Checkbox v-model="excelMappingForm.is_default">设为默认配置</Checkbox>
              </FormItem>
              <FormItem label="备注">
                <Input v-model="excelMappingForm.remark" type="textarea" :rows="2" placeholder="请输入备注" />
              </FormItem>
              <FormItem label="字段映射">
                <div style="width: 100%;">
                  <Button type="primary" size="small" @click="handleAddFieldMapping" style="margin-bottom: 10px;">添加字段</Button>
                  <div style="margin-bottom: 10px; font-size: 12px; color: #666;">
                    <span style="margin-right: 20px;">💡 组合表达式说明：</span>
                    <span style="margin-right: 15px;">{列名} - 引用Excel列</span>
                    <span>示例：{薪资上限}+"-"+{薪资下限}+"元/月"</span>
                  </div>
                  <Table
                    :key="tableKey"
                    :columns="fieldMappingColumns"
                    :data="excelMappingForm.field_mappings"
                    border
                    size="small"
                    max-height="300"
                  >
                    <template slot-scope="{ row, index }" slot="excel_field">
                      <el-input v-model="excelMappingForm.field_mappings[index].excel_field" placeholder="Excel列名" size="small" />
                    </template>
                    <template slot-scope="{ row, index }" slot="mapping_type">
                      <el-select v-model="excelMappingForm.field_mappings[index].mapping_type" placeholder="映射类型" size="small" style="width: 100%">
                        <el-option value="direct" label="直接映射" />
                        <el-option value="combine" label="字段组合" />
                        <el-option value="prefix" label="前缀" />
                        <el-option value="suffix" label="后缀" />
                        <el-option value="prefix_suffix" label="前后缀" />
                      </el-select>
                    </template>
                    <template slot-scope="{ row, index }" slot="combine_expression">
                      <el-input
                        v-model="excelMappingForm.field_mappings[index].combine_expression"
                        placeholder="组合表达式，如：{上限}+'-'+{下限}"
                        size="small"
                        v-if="excelMappingForm.field_mappings[index].mapping_type === 'combine'"
                      />
                      <span v-else style="color: #999; font-size: 12px;">-</span>
                    </template>
                    <template slot-scope="{ row, index }" slot="value_transform">
                      <el-select v-model="excelMappingForm.field_mappings[index].value_transform" placeholder="值转换" size="small" style="width: 100%">
                        <el-option value="none" label="不转换" />
                        <el-option value="CNtoCode" label="CNtoCode" />
                      </el-select>
                    </template>
                    <template slot-scope="{ row, index }" slot="prefix">
                      <el-input v-model="excelMappingForm.field_mappings[index].prefix" placeholder="前缀" size="small" />
                    </template>
                    <template slot-scope="{ row, index }" slot="suffix">
                      <el-input v-model="excelMappingForm.field_mappings[index].suffix" placeholder="后缀" size="small" />
                    </template>
                    <template slot-scope="{ row, index }" slot="table_name">
                      <el-select v-model="excelMappingForm.field_mappings[index].table_name" placeholder="选择表" size="small" style="width: 100%">
                        <el-option value="company_info" label="company_info" />
                        <el-option value="job_info" label="job_info" />
                      </el-select>
                    </template>
                    <template slot-scope="{ row, index }" slot="table_field">
                      <el-input v-model="excelMappingForm.field_mappings[index].table_field" placeholder="字段名" size="small" />
                    </template>
                    <template slot-scope="{ row, index }" slot="required">
                      <el-checkbox v-model="excelMappingForm.field_mappings[index].required">必填</el-checkbox>
                    </template>
                    <template slot-scope="{ row, index }" slot="action">
                      <Button type="error" size="small" @click="handleRemoveFieldMapping(index)">删除</Button>
                    </template>
                  </Table>
                </div>
              </FormItem>
            </Form>
          </div>
        </TabPane>
      </Tabs>
      <div slot="footer">
        <Button @click="excelMappingModalVisible = false">关闭</Button>
        <Button v-if="excelMappingActiveTab === 'edit'" type="primary" @click="handleSaveExcelMapping">保存</Button>
        <Button v-if="excelMappingActiveTab === 'edit'" @click="excelMappingActiveTab = 'list'">返回列表</Button>
      </div>
    </Modal>

  </div>
</template>

<script>

  import { getJobfairlist,
    operationJobfair,
    getMarketlist,
    changeJobfair,
    uptotcrc,
    getJobfairBoothList,
    getJobfairJobList,
    updateJobfairBooth,
    updateJobfairBoothState,
    getExcelImportMappingList,
    getExcelImportMappingDetail,
    saveExcelImportMapping,
    deleteExcelImportMapping
  } from '@/api/scinfo/scinfo.js'

  import { getsysparameterList } from '@/api/system/sys_parameter'
  import { mapState } from 'vuex'
  import * as XLSX from 'xlsx'

  // import {Notification} from 'element-ui';

  let moment = require('moment')
  export default {

    computed: {
     ...mapState({
      rules: state => state.user.rules
    })
    },

    data () {
      return {
        spinShow: false,
        operationWidth: 300, // 操作列宽度，根据权限动态调整
        fullscreenLoading: false,
        JtypeList: [],
        MarketList: [],
        formValidate: {
          Id: 0,
          Mid: 0,
          Jname: '',
          Jstime: '',
          Jtype: 0,
          Jotime: '',
          Jstate: 0,
          Jnum: 0
        },
        searchVal: '',
        tableData: [],
        modalMap: {
          modalVisible: false,
          modalTitle: '新建'
        },
        tableSelectIdList: [],
        editModalData: '',
        pageNum: 1, // 当前页码
        pageTotal: 0, // 数据总数
        pageSize: 15, // 每页条数

        // 导入进度相关
        importProgressVisible: false,
        importPercent: 0,
        importStatus: 'normal',
        importProgressText: '',
        importStatusText: '',

        // 查看摊位相关
        boothModalVisible: false,
        boothModalTitle: '查看摊位',
        boothActiveTab: 'booth',
        boothLoading: false,
        boothData: [],
        boothPageNum: 1,
        boothPageSize: 10,
        boothTotal: 0,
        jobLoading: false,
        jobData: [],
        jobPageNum: 1,
        jobPageSize: 10,
        jobTotal: 0,
        currentJobfairId: null,
        currentBoothId: null,
        isViewAllJobs: true,  // true=查看全部, false=查看某个摊位的

        // 修改摊位号相关
        editBoothModalVisible: false,
        editBoothForm: {
          applyId: null,
          companyName: '',
          currentNum: '',
          newNum: ''
        },
        editBoothRules: {
          newNum: [
            { type: 'number', min: 1, message: '摊位号必须大于0', trigger: 'blur' }
          ]
        },

        // Excel导入字段映射相关
        excelMappingModalVisible: false,
        excelMappingActiveTab: 'list',
        excelMappingLoading: false,
        excelMappingData: [],
        excelMappingTotal: 0,
        excelMappingPageNum: 1,
        excelMappingPageSize: 10,
        excelMappingForm: {
          id: null,
          mapping_name: '',
          jobfair_id: null,
          header_row: 2,
          data_start_row: 3,
          field_mappings: [],
          is_active: 1,
          is_default: 0,
          remark: ''
        },
        excelMappingRules: {
          mapping_name: [
            { required: true, message: '请输入配置名称', trigger: 'blur' }
          ],
          header_row: [
            { required: true, type: 'number', message: '请输入字段行号', trigger: 'blur' }
          ],
          data_start_row: [
            { required: true, type: 'number', message: '请输入数据起始行号', trigger: 'blur' }
          ]
        },

        excelMappingColumns: [
          { title: 'ID', key: 'id', width: 80 },
          { title: '配置名称', key: 'mapping_name', width: 200, tooltip: true },
          { title: '字段行号', key: 'header_row', width: 100 },
          { title: '数据起始行', key: 'data_start_row', width: 100 },
          { title: '是否默认', key: 'is_default', width: 100, render: (h, params) => {
            return h('Tag', { props: { color: params.row.is_default ? 'success' : 'default' } }, params.row.is_default ? '是' : '否')
          }},
          { title: '创建时间', key: 'create_time', width: 180 },
          { title: '备注', key: 'remark', width: 150, tooltip: true },
          { title: '操作', slot: 'action', width: 280, fixed: 'right' }
        ],

        // 用于强制刷新 Table 组件 (解决 iView Table slot-scope 响应式问题)
        tableKey: 0,

        fieldMappingColumns: [
          { title: 'Excel列名', slot: 'excel_field', width: 140 },
          { title: '映射类型', slot: 'mapping_type', width: 110 },
          { title: '组合表达式', slot: 'combine_expression', width: 220 },
          { title: '值转换', slot: 'value_transform', width: 100 },
          { title: '前缀', slot: 'prefix', width: 90 },
          { title: '后缀', slot: 'suffix', width: 90 },
          { title: '目标表', slot: 'table_name', width: 130 },
          { title: '目标字段', slot: 'table_field', width: 130 },
          { title: '必填', slot: 'required', width: 70, align: 'center' },
          { title: '操作', slot: 'action', width: 90, align: 'center' }
        ],

        boothColumns: [
          { title: 'ID', key: 'id', width: 80 },
          { title: '企业名称', key: 'C_Cname', width: 220, tooltip: true },
          { title: '联系人', key: 'linkman', width: 120 },
          { title: '联系电话', key: 'phone', width: 140 },
          { title: '职位数', key: 'job_count', width: 80 },
          { title: '岗位数', key: 'job_num_sum', width: 80 },
          { title: '摊位号', key: 'booth_num', width: 100 },
          {
            title: '状态',
            key: 'astate',
            width: 120,
            render: (h, params) => {
              const astate = params.row.astate !== undefined ? params.row.astate : 1
              return h('i-switch', {
                props: {
                  value: astate,
                  trueValue: 1,
                  falseValue: 0,
                  trueColor: '#19be6b',
                  falseColor: '#ff9900'
                },
                on: {
                  'on-change': (value) => {
                    this.handleBoothStateChange(params.row, value)
                  }
                }
              })
            }
          },
          { title: '操作', slot: 'action', width: 220, fixed: 'right' }
        ],

        jobColumns: [
          { title: 'ID', key: 'Id', width: 80 },
          { title: '企业名称', key: 'C_Cname', width: 200, tooltip: true },
          { title: '职位名称', key: 'Jobname', width: 200, tooltip: true },
          { title: '招聘人数', key: 'Jnum', width: 100 },
          { title: '薪资', key: 'Jsalary_CN', width: 150 },
          { title: '学历', key: 'Jeducation_CN', width: 120 },
          { title: '联系人', key: 'Jlinkman', width: 120 },
          { title: '联系电话', key: 'Jphone', width: 150 },
          { title: '状态', key: 'Jstate_CN', width: 100 }
        ],

        ruleValidate: {
          // admin_user: [{ required: true, message: "请选择管理用户", trigger: "change"}],
          Jname: [
            {
              required: true,
              message: '招聘会主题不能为空',
              trigger: 'blur'
            }
          ],

          Jstime: [
            {
              required: true,
              type: 'date',
              message: '开始时间不能为空',
              trigger: 'blur'
            }
          ],
          Jotime: [
            {
              required: true,
              type: 'date',
              message: '结束时间不能为空',
              trigger: 'blur'
            }
          ],
          Jtype: [
            {
              required: true,
              message: '请选择类型',
              trigger: 'change'
            }
          ],
          Mid: [
            {
              required: true,
              message: '请选择市场',
              trigger: 'change'
            }
          ]

        },
        columns: [
          {
            type: 'selection',
            key: 'id',
            width: 60,
            fixed: 'left',
            align: 'center'
          },
          {
            title: '招聘会主题',
            key: 'Jname',
            align: 'center',
            width: 200,
            fixed: 'left',
            sortable: true,
            tooltip: true
          },
          {
            title: '开始时间',
            key: 'Jstime',
            align: 'center',
            width: 200,
            fixed: 'left',
            sortable: true,
            tooltip: true
          },
          {
            title: '结束时间',
            key: 'Jotime',
            align: 'center',
            width: 200,
            sortable: true,
            tooltip: true
          },
          {
            title: '招聘市场',
            key: 'M_Mname',
            align: 'center',
            width: 200,
            fixed: 'left',
            sortable: true
          },
          {
            title: '单位/职位/岗位',
            key: 'statistics',
            align: 'center',
            tooltip: true,
            width: 220,
            render: (h, params) => {
              return h('div', { style: { fontSize: '12px' } }, [
                h('span', { style: { marginRight: '10px' } }, `单位: ${params.row.company_count || 0}`),
                h('span', { style: { marginRight: '10px' } }, `职位: ${params.row.job_count || 0}`),
                h('span', `岗位: ${params.row.job_num_sum || 0}`)
              ])
            }
          },
          // {
          //   title: '摊位情况',
          //   key: 'Jnum_ST',
          //   align: 'center',
          //   width: 200,
          //   sortable: true
          // },
          {
            title: '类型',
            key: 'Jtype_CN',
            align: 'center',
            width: 150,
            sortable: true
          },
          {
            title: '状态',
            key: 'Jstate_CN',
            align: 'center',
            width: 100,
            fixed: 'right',
            sortable: true
          },

          {
            title: '操作',
            key: 'handle',
            width: 350,
            align: 'center',
            fixed: 'right',
            render: (h, params) => {
              if (params.row.Jstate == 1) {
                return h('div', [
                  // h(
                  //   'Button',
                  //   {
                  //     props: {
                  //       type: 'warning',
                  //       size: 'small'
                  //     },
                  //     style: {
                  //       marginRight: '5px'
                  //     },
                  //     on: {
                  //       click: () => {
                  //         this.uptotcrc(params.row)
                  //       }
                  //     }
                  //   },
                  //   '更新'
                  // ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'primary',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.editModal(params.row, 'put', '修改')
                        }
                      }
                    },
                    '编辑'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'success',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.handleViewBooth(params.row)
                        }
                      }
                    },
                    '查看摊位'
                  ),
                  this.rules.excel_import_btn && h(
                    'Button',
                    {
                      props: {
                        type: 'info',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.handleImportJobs(params.row)
                        }
                      }
                    },
                    '导入职位'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.changstate(params.row)
                        }
                      }
                    },
                    '暂停'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small'
                      },
                      on: {
                        click: () => {
                          this.delData(params)
                        }
                      }
                    },
                    '删除'
                  )
                ])
              } else if (params.row.Jstate == 2) {
                return h('div', [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'primary',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.editModal(params.row, 'put', '修改')
                        }
                      }
                    },
                    '编辑'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'success',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.handleViewBooth(params.row)
                        }
                      }
                    },
                    '查看摊位'
                  ),
                  this.rules.excel_import_btn && h(
                    'Button',
                    {
                      props: {
                        type: 'info',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.handleImportJobs(params.row)
                        }
                      }
                    },
                    '导入职位'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'success',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.changstate(params.row)
                        }
                      }
                    },
                    '启用'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small'
                      },
                      on: {
                        click: () => {
                          this.delData(params)
                        }
                      }
                    },
                    '删除'
                  )
                ])
              } else {
                return h('div', [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'primary',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.editModal(params.row, 'put', '修改')
                        }
                      }
                    },
                    '编辑'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'success',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.handleViewBooth(params.row)
                        }
                      }
                    },
                    '查看摊位'
                  ),
                  this.rules.excel_import_btn && h(
                    'Button',
                    {
                      props: {
                        type: 'info',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.handleImportJobs(params.row)
                        }
                      }
                    },
                    '导入职位'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small'
                      },
                      on: {
                        click: () => {
                          this.delData(params)
                        }
                      }
                    },
                    '删除'
                  )
                ])
              }
            }
          }
        ]
      }
    },
    methods: {

      getJobfairlist (key, value) {
        this.spinShow = true
        getJobfairlist(this.pageNum, this.pageSize, key, value).then(res => {
          if (res.data.code === 0) {
            this.pageTotal = res.data.count
            this.tableData = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
          this.spinShow = false
        })
      },

      handleRemove (index) {
        this.formValidate.args_items[index].status = 0
      },

      // table 选中的ID
      handleSelectChange (val) {
        let SelectIdList = []
        val.forEach(item => {
          SelectIdList.push(item.Id)
        })

        this.tableSelectIdList = SelectIdList
      },

      closeModal () {
        this.dialog.show = false
      },
      getJtypeList () {
        getsysparameterList('jobfair_info', 'Jtype').then(res => {
          if (res.data.code === 0) {
            this.JtypeList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      },
      getMarketList () {
        getMarketlist().then(res => {
          if (res.data.code === 0) {
            this.MarketList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      },
      uptotcrc (paramsRow) {
        setTimeout(() => {
          uptotcrc(paramsRow).then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)

              if (this.searchVal) {
                this.getJobfairlist(this.searchVal)
              } else {
                this.getJobfairlist()
              }
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        }, 1000)
      },
      changstate (paramsRow) {
        setTimeout(() => {
          changeJobfair(paramsRow, 'PUT').then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)

              if (this.searchVal) {
                this.getJobfairlist(this.searchVal)
              } else {
                this.getJobfairlist()
              }
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        }, 1000)
      },
      editModal (paramsRow, meth, mtitle) {
        this.modalMap.modalVisible = true
        this.modalMap.modalTitle = mtitle
        this.editModalData = meth
        this.getJtypeList()
        this.getMarketList()
        var day2 = new Date()
        day2.setTime(day2.getTime())
        var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
        if (paramsRow && paramsRow.Id) {
          this.formValidate = {
            Id: paramsRow.Id,
            Mid: paramsRow.Mid.toString(),
            Jname: paramsRow.Jname,
            Jstime: paramsRow.Jstime,
            Jtype: paramsRow.Jtype.toString(),
            Jotime: paramsRow.Jotime,
            Jstate: paramsRow.Jstate,
            Jnum: paramsRow.Jnum
          }
        } else {
          this.formValidate = {
            Id: 0,
            Mid: 0,
            Jname: '',
            Jstime: s2,
            Jtype: 1,
            Jotime: s2,
            Jstate: 1,
            Jnum: 0
          }
        }
      },
      handleSubmit (value) {
        this.$refs[value].validate((valid) => {
          if (valid) {
            setTimeout(() => {
              this.formValidate.Jstime = moment(this.formValidate.Jstime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
              this.formValidate.Jotime = moment(this.formValidate.Jotime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
              operationJobfair(this.formValidate, this.editModalData).then(res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)

                  if (this.searchVal) {
                    this.getJobfairlist(this.searchVal)
                  } else {
                    this.getJobfairlist()
                  }

                  this.modalMap.modalVisible = false
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
            }, 1000)
            // this.$Message.success('Success!');
          } else {
            this.$Message.error('缺少必要参数')
          }
        })
      },

      handleReset (name) {
        this.$refs[name].resetFields()
      },

      handlerDelete () {
        // console.log(this.tableSelectIdList.length)
        if (this.tableSelectIdList.length > 0) {
          if (confirm(`确定要批量删除选中设备 `)) {
            operationJobfair({ 'id_list': this.tableSelectIdList }, 'delete').then(
              res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)
                  this.getJobfairlist(this.searchVal)
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
          }
        } else {
          this.$Message.info(`你总要选中点什么吧`)
        }
      },
      // 删除
      delData (params) {
        if (confirm(`确定要删除 ${params.row.Jname}`)) {
          // console.log(params.row.id)
          operationJobfair(
            {
              'id': params.row.Id
            },
            'delete'
          ).then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)
              this.tableData.splice(params.index, 1)
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        }
      },

      handleSearch () {
        this.getJobfairlist(this.searchVal)
      },
      // 点击节点
      // 翻页
      changePage (value) {
        this.pageNum = value
        if (this.searchVal) {
          this.getJobfairlist(this.searchVal)
        } else {
          this.getJobfairlist()
        }
      },
      // 切换分页
      handlePageSize (value) {
        this.pageSize = value
        this.pageNum = 1
        if (this.searchVal) {
          this.getJobfairlist(this.searchVal)
        } else {
          this.getJobfairlist()
        }
      },
      searchinput () {
        if (this.searchVal) {
          this.getJobfairlist(this.searchVal)
        } else {
          this.getJobfairlist()
        }
      },

      // 导入职位
      handleImportJobs (paramsRow) {
        // 创建文件上传 input
        const input = document.createElement('input')
        input.type = 'file'
        input.accept = '.xls,.xlsx'
        input.onchange = async (e) => {
          const file = e.target.files[0]
          if (!file) return

          this.$Modal.confirm({
            title: '职位导入',
            content: `确定要导入 "${file.name}" 到招聘会 "${paramsRow.Jname}" 吗？`,
            onOk: async () => {
              await this.importExcel(file, paramsRow.Id)
            }
          })
        }
        input.click()
      },

      // 导入 Excel 文件
      async importExcel (file, jobfairId) {
        try {
          this.$Message.info('正在解析 Excel 文件...')

          // 使用 xlsx 库读取 Excel 文件
          const reader = new FileReader()
          reader.onload = async (e) => {
            try {
              const data = new Uint8Array(e.target.result)
              const workbook = XLSX.read(data, { type: 'array' })
              const firstSheetName = workbook.SheetNames[0]
              const worksheet = workbook.Sheets[firstSheetName]
              const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 })

              // 发送数据到后端
              await this.sendImportData(jsonData, file.name, jobfairId)
            } catch (error) {
              console.error('解析 Excel 文件失败:', error)
              this.$Message.error('解析 Excel 文件失败')
            }
          }

          reader.onerror = () => {
            this.$Message.error('读取文件失败')
          }

          reader.readAsArrayBuffer(file)
        } catch (error) {
          console.error('导入 Excel 文件失败:', error)
          this.$Message.error('导入 Excel 文件失败')
        }
      },

      // 发送导入数据到后端
      async sendImportData (dataList, filename, jobfairId) {
        try {
          // 初始化进度窗口
          this.importProgressVisible = true
          this.importPercent = 0
          this.importStatus = 'normal'
          this.importProgressText = '正在建立连接...'
          this.importStatusText = '准备中'

          // 建立 WebSocket 连接
          const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
          const wsUrl = `${protocol}//${window.location.host}/m_ws/cmd/jobfair/job/import/mapping`
          const ws = new WebSocket(wsUrl)

          ws.onopen = () => {
            this.importProgressText = '连接成功，准备导入数据...'
            this.importStatusText = '建立连接'
            // 发送数据
            ws.send(JSON.stringify({
              data_list: dataList,
              filename: filename,
              jobfair_id: jobfairId
            }))
          }

          ws.onmessage = (event) => {
            let message
            try {
              message = JSON.parse(event.data)
            } catch (e) {
              // 如果不是 JSON 格式，忽略
              return
            }

            if (message.code === 1) {
              // 处理进度信息
              const percent = Math.round(message.percent)
              const current = message.index
              const total = message.max
              this.importPercent = percent
              this.importProgressText = `正在导入：${current}/${total}`
              // 显示详细的进度信息
              if (message.result) {
                console.log('导入进度:', message.result)
                this.importStatusText = message.result
              } else {
                this.importStatusText = '导入中'
              }
            } else if (message.code === 0) {
              // 导入完成
              this.importPercent = 100
              this.importStatus = 'success'
              this.importProgressText = message.msg
              this.importStatusText = '导入完成'

              // 延迟关闭窗口
              setTimeout(() => {
                this.importProgressVisible = false
                this.$Message.success('导入成功')
                if (this.searchVal) {
                  this.getJobfairlist(this.searchVal)
                } else {
                  this.getJobfairlist()
                }
              }, 2000)
              ws.close()
            } else if (message.code === -1) {
              // 导入失败
              this.importStatus = 'error'
              this.importProgressText = message.msg || '导入失败'
              this.importStatusText = '导入失败'

              setTimeout(() => {
                this.importProgressVisible = false
                this.$Message.error(message.msg || '导入失败')
              }, 2000)
              ws.close()
            }
          }

          ws.onerror = (error) => {
            this.importStatus = 'error'
            this.importProgressText = 'WebSocket 连接错误'
            this.importStatusText = '连接失败'

            setTimeout(() => {
              this.importProgressVisible = false
              this.$Message.error('WebSocket 连接错误')
            }, 2000)
            console.error('WebSocket 错误:', error)
          }

          ws.onclose = () => {
            this.loading = false
          }
        } catch (error) {
          this.importProgressVisible = false
          this.loading = false
          console.error('发送导入数据失败:', error)
          this.$Message.error('发送导入数据失败')
        }
      },

      // 查看摊位
      handleViewBooth (paramsRow) {
        this.currentJobfairId = paramsRow.Id
        this.currentBoothId = null
        this.isViewAllJobs = true  // 重置为查看全部
        this.boothModalTitle = `查看摊位 - ${paramsRow.Jname}`
        this.boothModalVisible = true
        this.boothActiveTab = 'booth'
        this.getBoothList()
      },

      // 获取摊位列表
      async getBoothList () {
        this.boothLoading = true
        try {
          const res = await getJobfairBoothList(this.currentJobfairId, this.boothPageNum, this.boothPageSize)
          if (res.data.code === 0) {
            this.boothData = res.data.data || []
            this.boothTotal = res.data.total || 0
          } else {
            this.$Message.error(res.data.msg || '获取摊位列表失败')
          }
        } catch (error) {
          this.$Message.error('获取摊位列表失败')
          console.error(error)
        } finally {
          this.boothLoading = false
        }
      },

      // 摊位列表翻页
      changeBoothPage (value) {
        this.boothPageNum = value
        this.getBoothList()
      },

      // 摊位列表切换每页数量
      handleBoothPageSize (value) {
        this.boothPageSize = value
        this.boothPageNum = 1
        this.getBoothList()
      },

      // 查看摊位的职位
      handleViewBoothJobs (row) {
        this.currentBoothId = row.Id
        this.isViewAllJobs = false
        this.boothActiveTab = 'jobs'
        this.getJobList(row)
      },

      // 获取职位列表
      async getJobList (boothRow = null) {
        this.jobLoading = true
        try {
          const res = await getJobfairJobList(this.currentJobfairId, this.jobPageNum, this.jobPageSize)
          if (res.data.code === 0) {
            let allJobs = res.data.data || []

            if (!this.isViewAllJobs && boothRow) {
              // 只显示该摊位的职位
              if (boothRow.ajobs && boothRow.ajobs !== 'None') {
                const jobIds = boothRow.ajobs.split(',').map(id => parseInt(id))
                allJobs = allJobs.filter(job => jobIds.includes(job.Id))
              } else {
                allJobs = []
              }
            }

            this.jobData = allJobs
            this.jobTotal = res.data.total || 0
          } else {
            this.$Message.error(res.data.msg || '获取职位列表失败')
          }
        } catch (error) {
          this.$Message.error('获取职位列表失败')
          console.error(error)
        } finally {
          this.jobLoading = false
        }
      },

      // 职位列表翻页
      changeJobPage (value) {
        this.jobPageNum = value
        this.getJobList()
      },

      // 职位列表切换每页数量
      handleJobPageSize (value) {
        this.jobPageSize = value
        this.jobPageNum = 1
        this.getJobList()
      },

      // 修改摊位号
      handleEditBoothNum (row) {
        this.editBoothForm.applyId = row.id
        this.editBoothForm.companyName = row.C_Cname || ''
        this.editBoothForm.currentNum = row.booth_num || ''
        this.editBoothForm.newNum = ''
        this.editBoothModalVisible = true
      },

      // 保存摊位号
      async handleSaveBoothNum () {
        // 手动检查newNum是否为空或无效数值
        const newNum = this.editBoothForm.newNum
        console.log(newNum)
        if (newNum === null || newNum === '' || newNum === undefined ) {
          this.$Message.error('请输入新摊位号')
          return
        }

        // 确保转换为数字
        // const numValue = Number(newNum)
        // if (numValue < 1) {
        //   this.$Message.error('摊位号必须大于0')
        //   return
        // }

        this.$refs.editBoothForm.validate(async (valid) => {
          if (valid) {
            try {
              const res = await updateJobfairBooth({
                apply_id: this.editBoothForm.applyId,
                new_ajnum: this.editBoothForm.newNum
              })
              if (res.data.code === 0) {
                this.$Message.success(res.data.msg || '修改成功')
                this.editBoothModalVisible = false
                // 刷新摊位列表
                await this.getBoothList()
              } else {
                this.$Message.error(res.data.msg || '修改失败')
              }
            } catch (error) {
              this.$Message.error('修改失败')
              console.error(error)
            }
          }
        })
      },

      // 切换摊位状态
      async handleBoothStateChange (row, newState) {
        try {
          console.log(newState)
          const res = await updateJobfairBoothState({
            apply_id: row.id,
            astate: newState.toString()
          })
          if (res.data.code === 0) {
            this.$Message.success(res.data.msg || '状态更新成功')
            // 刷新摊位列表
            await this.getBoothList()
          } else {
            this.$Message.error(res.data.msg || '状态更新失败')
            // 刷新列表恢复原状态
            await this.getBoothList()
          }
        } catch (error) {
          this.$Message.error('状态更新失败')
          console.error(error)
          // 刷新列表恢复原状态
          await this.getBoothList()
        }
      },

      // ==================== Excel导入字段映射相关方法 ====================

      // 打开导入字段设置
      handleExcelImportMapping () {
        this.excelMappingModalVisible = true
        this.excelMappingActiveTab = 'list'
        this.getExcelMappingList()
      },

      // 获取字段映射配置列表
      async getExcelMappingList () {
        this.excelMappingLoading = true
        try {
          const res = await getExcelImportMappingList(this.excelMappingPageNum, this.excelMappingPageSize)
          if (res.data.code === 0) {
            this.excelMappingTotal = res.data.count
            let mappingData = res.data.data || []
            // 确保每个配置的field_mappings都有正确的格式
            mappingData = mappingData.map(item => {
              if (item.field_mappings) {
                try {
                  let fieldMappings = JSON.parse(item.field_mappings)
                  // 确保每个字段映射都有所有必需的字段
                  fieldMappings = fieldMappings.map(m => ({
                    excel_field: m.excel_field || '',
                    mapping_type: m.mapping_type || 'direct',
                    value_transform: m.value_transform || 'none',
                    prefix: m.prefix || '',
                    suffix: m.suffix || '',
                    table_name: m.table_name || 'company_info',
                    table_field: m.table_field || '',
                    required: m.required || false,
                    combine_expression: m.combine_expression || '',
                  }))
                  item.field_mappings = fieldMappings
                } catch (e) {
                  console.error('解析field_mappings失败:', e)
                  item.field_mappings = []
                }
              }
              return item
            })
            this.excelMappingData = mappingData
          } else {
            this.$Message.error(res.data.msg || '获取配置列表失败')
          }
        } catch (error) {
          this.$Message.error('获取配置列表失败')
          console.error(error)
        } finally {
          this.excelMappingLoading = false
        }
      },

      // 切换字段映射配置分页
      changeExcelMappingPage (value) {
        this.excelMappingPageNum = value
        this.getExcelMappingList()
      },

      // 切换字段映射配置每页数量
      handleExcelMappingPageSize (value) {
        this.excelMappingPageSize = value
        this.excelMappingPageNum = 1
        this.getExcelMappingList()
      },

      // 新增字段映射配置
      handleAddMapping () {
        // 使用 $set 确保响应式正确建立
        const defaultMappings = [
          { excel_field: '单位名称', mapping_type: 'direct', value_transform: 'none', prefix: '', suffix: '', table_name: 'company_info', table_field: 'Cname', required: true, combine_expression: '' },
          { excel_field: '联系人', mapping_type: 'direct', value_transform: 'none', prefix: '', suffix: '', table_name: 'company_info', table_field: 'Ccontacts', required: true, combine_expression: '' },
          { excel_field: '联系电话', mapping_type: 'direct', value_transform: 'none', prefix: '', suffix: '', table_name: 'company_info', table_field: 'Cphone', required: true, combine_expression: '' },
          { excel_field: '岗位名称', mapping_type: 'direct', value_transform: 'none', prefix: '', suffix: '', table_name: 'job_info', table_field: 'Jobname', required: true, combine_expression: '' }
        ]
        // 直接替换整个数组，确保 Vue 2 响应式正确
        this.excelMappingForm.field_mappings = defaultMappings
        // 更新其他字段
        this.excelMappingForm.id = null
        this.excelMappingForm.mapping_name = ''
        this.excelMappingForm.jobfair_id = null
        this.excelMappingForm.header_row = 2
        this.excelMappingForm.data_start_row = 3
        this.excelMappingForm.is_active = 1
        this.excelMappingForm.is_default = 0
        this.excelMappingForm.remark = ''
        this.excelMappingActiveTab = 'edit'
        // 强制刷新 Table 组件 (解决 iView Table slot-scope 响应式问题)
        this.tableKey++
      },

      // 编辑字段映射配置
      async handleEditMapping (row) {
        try {
          const res = await getExcelImportMappingDetail(row.id)
          if (res.data.code === 0) {
            const data = res.data.data
            let fieldMappings = []
            if (data.field_mappings) {
              try {
                fieldMappings = JSON.parse(data.field_mappings)
                // 确保每个字段映射都有所有必需的字段
                fieldMappings = fieldMappings.map(m => ({
                  excel_field: m.excel_field || '',
                  mapping_type: m.mapping_type || 'direct',
                  value_transform: m.value_transform || 'none',
                  prefix: m.prefix || '',
                  suffix: m.suffix || '',
                  table_name: m.table_name || 'company_info',
                  table_field: m.table_field || '',
                  required: m.required || false,
                  combine_expression: m.combine_expression || ""
                }))
              } catch (e) {
                console.error('解析field_mappings失败:', e)
                fieldMappings = []
              }
            }
        // 直接替换整个数组，确保 Vue 2 响应式正确
            this.excelMappingForm.field_mappings = fieldMappings
            // 更新其他字段
            this.excelMappingForm.id = data.id
            this.excelMappingForm.mapping_name = data.mapping_name
            this.excelMappingForm.jobfair_id = data.jobfair_id
            this.excelMappingForm.header_row = data.header_row
            this.excelMappingForm.data_start_row = data.data_start_row
            this.excelMappingForm.is_active = data.is_active
            this.excelMappingForm.is_default = data.is_default
            this.excelMappingForm.remark = data.remark
            this.excelMappingActiveTab = 'edit'
            // 强制刷新 Table 组件 (解决 iView Table slot-scope 响应式问题)
            this.tableKey++
          } else {
            this.$Message.error(res.data.msg || '获取配置详情失败')
          }
        } catch (error) {
          this.$Message.error('获取配置详情失败')
          console.error(error)
        }
      },

      // 设为默认配置
      async handleSetDefaultMapping (row) {
        try {
          const res = await saveExcelImportMapping({
            id: row.id,
            mapping_name: row.mapping_name,
            header_row: row.header_row,
            data_start_row: row.data_start_row,
            field_mappings: row.field_mappings,
            is_default: 1
          })
          if (res.data.code === 0) {
            this.$Message.success('设置成功')
            // 只更新本地数据，不重新加载列表
            this.excelMappingData.forEach(item => {
              item.is_default = item.id === row.id ? 1 : 0
            })
          } else {
            this.$Message.error(res.data.msg || '设置失败')
          }
        } catch (error) {
          this.$Message.error('设置失败')
          console.error(error)
        }
      },

      // 删除字段映射配置
      handleDeleteMapping (row) {
        this.$Modal.confirm({
          title: '确认删除',
          content: `确定要删除配置 "${row.mapping_name}" 吗？`,
          onOk: async () => {
            try {
              const res = await deleteExcelImportMapping({ id: row.id })
              if (res.data.code === 0) {
                this.$Message.success('删除成功')
                // 只从本地数据中移除，不重新加载列表
                const index = this.excelMappingData.findIndex(item => item.id === row.id)
                if (index > -1) {
                  this.excelMappingData.splice(index, 1)
                  this.excelMappingTotal--
                }
              } else {
                this.$Message.error(res.data.msg || '删除失败')
              }
            } catch (error) {
              this.$Message.error('删除失败')
              console.error(error)
            }
          }
        })
      },

      // 添加字段映射
      handleAddFieldMapping () {
        this.excelMappingForm.field_mappings.push({
          excel_field: '',
          mapping_type: 'direct',
          value_transform: 'none',
          prefix: '',
          suffix: '',
          table_name: 'company_info',
          table_field: '',
          required: false,
          combine_expression: ''
        })
      },

      // 移除字段映射
      handleRemoveFieldMapping (index) {
        this.excelMappingForm.field_mappings.splice(index, 1)
      },

      // 保存字段映射配置
      async handleSaveExcelMapping () {
        this.$refs.excelMappingForm.validate(async (valid) => {
          if (valid) {
            try {
              // 验证字段映射 - 暂时跳过严格验证，先看看数据是否正确
              console.log('准备保存，field_mappings:', this.excelMappingForm.field_mappings)
              console.log('准备保存的完整表单:', this.excelMappingForm)

              // 暂时跳过验证，先测试保存功能
              // const invalidMappings = this.excelMappingForm.field_mappings.filter(m => {
              //   console.log('检查字段映射:', m)
              //   // 确保字段都有值
              //   const hasExcelField = m.excel_field && m.excel_field.trim() !== ''
              //   const hasTableField = m.table_field && m.table_field.trim() !== ''
              //
              //   console.log('hasExcelField:', hasExcelField, 'hasTableField:', hasTableField)
              //
              //   if (m.mapping_type === 'combine') {
              //     // 组合类型只需要excel_field
              //     return !hasExcelField
              //   } else {
              //     // 其他类型需要excel_field和table_field
              //     return !hasExcelField || !hasTableField
              //   }
              // })
              // console.log('invalidMappings:', invalidMappings)
              // if (invalidMappings.length > 0) {
              //   this.$Message.error('请填写完整的字段映射信息')
              //   return
              // }

              // 使用深拷贝确保提交的数据是最新的
              const fieldMappingsCopy = JSON.parse(JSON.stringify(this.excelMappingForm.field_mappings))

              const res = await saveExcelImportMapping({
                id: this.excelMappingForm.id,
                mapping_name: this.excelMappingForm.mapping_name,
                jobfair_id: this.excelMappingForm.jobfair_id,
                header_row: this.excelMappingForm.header_row,
                data_start_row: this.excelMappingForm.data_start_row,
                field_mappings: fieldMappingsCopy,
                is_active: this.excelMappingForm.is_active,
                is_default: this.excelMappingForm.is_default,
                remark: this.excelMappingForm.remark
              })
              if (res.data.code === 0) {
                this.$Message.success('保存成功')
                this.excelMappingActiveTab = 'list'
                this.getExcelMappingList()
              } else {
                this.$Message.error(res.data.msg || '保存失败')
              }
            } catch (error) {
              this.$Message.error('保存失败')
              console.error(error)
            }
          }
        })
      }
    },

    watch: {
      searchVal (val) {
        this.searchVal = val
        // this.getServerList(this.searchVal)
      },
      boothActiveTab (newVal) {
        if (newVal === 'jobs') {
          // 切换到职位列表标签
          if (this.isViewAllJobs) {
            // 查看全部
            this.getJobList()
          }
        } else if (newVal === 'booth') {
          // 切换回摊位列表标签，重置为查看全部
          this.isViewAllJobs = true
          this.currentBoothId = null
        }
      }
    },
    mounted () {
      this.getJobfairlist()
      // 根据权限动态调整操作列宽度
      if (this.rules && this.rules.excel_import_btn) {
        this.operationWidth = 400
      }
    }
  }

</script>

<style lang="less" scoped>
  .search-con {
    padding: 10px 0;

    .search {
      &-col {
        display: inline-block;
        width: 200px;
      }

      &-input {
        display: inline-block;
        width: 200px;
        margin-left: 2px;
      }

      &-btn {
        margin-left: 2px;
      }
    }
  }
</style>
